import {
    DashboardPointInstance,
    PointInstanceConnectionStatus,
    PointInstanceStatus
} from "../../../../services/partnerCenterService";

export interface TenantListViewModel {
    ID: string;
    tenantName: string;
    plan?: string;
    licenseValid?: Date;
    totalUsers?: number;
    licensedUsers?: number;
    // storageUsage: string;
    url: string;
    hasFlag: boolean;
    isConnected: boolean;
}


export const mapDashboardPointInstancesResponse = (
    data: Array<DashboardPointInstance>
): Array<TenantListViewModel> =>
    data.map(instance => ({
        ID: instance.id,
        tenantName: instance.name,
        plan: instance.licenseData?.plan,
        licenseValid: instance.licenseData?.validUntil,
        totalUsers: instance.licenseData?.totalUsers,
        licensedUsers: instance.licenseData?.licensedUsers,
        // storageUsage: "N/A", // TODO: Replace with actual logic if storage usage is available
        url: instance.connectionStatus === PointInstanceConnectionStatus.Connected ? instance.url : 'Pending',
        hasFlag: instance.status === PointInstanceStatus.Error,
        isConnected: instance.connectionStatus === PointInstanceConnectionStatus.Connected
    }));
